import { EXACARE_LOGOS_S3_BUCKET_URLS } from '@/constants';

export const SplashScreen = () => (
  <div
    aria-label="Loading ExaCare AI"
    style={{
      position: 'fixed',
      inset: 0,
      zIndex: 10000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100vw',
      height: '100vh',
      background: `#e7f0f7 url(${EXACARE_LOGOS_S3_BUCKET_URLS.loadingBackground}) center / cover no-repeat`
    }}
  >
    <img
      src={EXACARE_LOGOS_S3_BUCKET_URLS.fullColored}
      alt="ExaCare Logo"
      style={{
        position: 'relative',
        zIndex: 1,
        maxWidth: 'min(316px, 72vw)',
        height: 'auto'
      }}
    />
  </div>
);
